import React, { useState } from "react";
import "./header.css";

const Header = () => {
  /*====== Change background header =======*/
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header");
    if (this.scrollY >= 80) header.classList.add("scroll-header");
    else header.classList.remove("scroll-header");
  });

  /*====== Toggle Menu =======*/
  const [Toggle, showMenu] = useState(false);
  const [activeNav, setActiveNav] = useState("#home");

  return (
    <header className="header">
      <nav className="nav container">
        <a href="/" className="nav__logo">
          {/* &lt;ateyob /&gt; */}
          {"<ateyob />"}
        </a>
        <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
          <ul className="nav__list grid justify-center items-center">
            <li className="nav__item">
              <a
                href="#home"
                onClick={() => setActiveNav("#home")}
                className={
                  activeNav === "#home" ? "nav__link active-link" : "nav__link"
                }
              >
                <i className="uil uil-estate nav__icon"></i>
                Home
              </a>
            </li>

            <li className="nav__item">
              <a
                href="#about"
                onClick={() => setActiveNav("#about")}
                className={
                  activeNav === "#about" ? "nav__link active-link" : "nav__link"
                }
              >
                <i className="uil uil-user nav__icon"></i>
                About
              </a>
            </li>
            <li className="nav__item">
              <a
                href="#skills"
                onClick={() => setActiveNav("#skills")}
                className={
                  activeNav === "#skills"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-file-alt nav__icon"></i>
                Skills
              </a>
            </li>
            <li className="nav__item">
              <a
                href="#services"
                onClick={() => setActiveNav("#services")}
                className={
                  activeNav === "#services"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-briefcase-alt nav__icon"></i>
                Services
              </a>
            </li>
            <li className="nav__item">
              <a
                href="#portfolio"
                onClick={() => setActiveNav("#portfolio")}
                className={
                  activeNav === "#portfolio"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-scenery nav__icon"></i>
                Portfolio
              </a>
            </li>
            <li className="nav__item">
              <a
                href="#contact"
                onClick={() => setActiveNav("#contact")}
                className={
                  activeNav === "#contact"
                    ? "nav__link active-link"
                    : "nav__link"
                }
              >
                <i className="uil uil-message nav__icon"></i>
                Contact
              </a>
            </li>

            <li class="nav__item">
              <a
                onClick={() => {
                  const body = document.body;
                  body.classList.toggle("dark-mode");
                  const sunIcon = document.querySelector(".uil-sun");
                  const moonIcon = document.querySelector(".uil-moon");
                  if (body.classList.contains("dark-mode")) {
                    moonIcon.classList.add("hidden");
                    sunIcon.classList.remove("hidden");
                  } else {
                    sunIcon.classList.add("hidden");
                    moonIcon.classList.remove("hidden");
                  }
                }}
                class="nav__link flex items-center"
              >
                <i class="uil uil-sun cursor-pointer text-yellow-500 text-xl hidden"></i>
                <i class="uil uil-moon cursor-pointer text-gray-500 text-xl"></i>
                {/* <span class="nav__text md:hidden ml-2">Dark Mode</span> */}
              </a>
            </li>

            {/* <li className="nav__item">
              <button className="mode__toggle" onClick={() => document.body.classList.toggle("dark-mode")}>
                <i className="uil uil-sun"></i>
              </button>
            </li> */}
          </ul>

          <i
            class="uil uil-times nav__close"
            onClick={() => showMenu(!Toggle)}
          ></i>
        </div>

        <div className="nav__toggle pr-10" onClick={() => showMenu(!Toggle)}>
          <i className="uil uil-apps"></i>
        </div>
      </nav>
    </header>
  );
};

export default Header;
